module.exports = __webpack_public_path__ + "img/Override_Indication.02010b0c.svg";